import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './SidebarNav.scss';
import UserIcon from 'Components/SiteNav/user-icon.svg';

const SidebarNav = ({ activeUser, activeSchool, items }) => {
  return (
    <div className="SidebarNav">
      <div className="SidebarNav__header">
        <div style={{ width: 45, marginRight: '0.8em' }}>
          <UserIcon />
        </div>
        <div>
          <div>
            {activeUser.given_name} {activeUser.family_name}
          </div>
          <div>
            <strong>{activeSchool.name}</strong>
          </div>
        </div>
      </div>
      {items.map((item) => (
        <NavLink
          className="SidebarNav__item"
          activeClassName="is-active"
          to={item.route}
          key={item.id}
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
};

export default SidebarNav;
